"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createRequestHandler;

var _relayRuntime = require("relay-runtime");

function createRequestHandler(customFetcher) {
  return function handleRequest(requestNode, variables, cacheConfig, uploadables) {
    return _relayRuntime.Observable.create(function (sink) {
      customFetcher(requestNode, variables, uploadables).then(function (response) {
        if (response.errors) {
          // There are several ways how to deal with the errors. We choose to always forward the
          // response if possible (via `sink.next`). However, servers can also mark the error as
          // being CRITICAL via `error.extensions.severity` in which case we try to halt the
          // application by propagating the error via `sink.error`.
          response.errors.forEach(function (error) {
            var _error$extensions;

            // See: https://github.com/facebook/relay/blob/db73f60fd42826c154353874e4bb1c54f0df1867/packages/relay-runtime/network/RelayNetworkTypes.js#L39
            if (((_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.severity) === 'CRITICAL') {
              sink.error(new Error(error.message));
            } else {
              // eslint-disable-next-line no-console
              console.warn(error.message, error);
            }
          });
        }

        sink.next(response);
      }).catch(function (error) {
        sink.error(error);
      }).then(function () {
        sink.complete();
      });
      return function cleanup() {// noop, do anything here (called after sink.complete or when Relay unsubscribes)
      };
    });
  };
}